/* eslint-disable no-case-declarations */
import { Record, RecordOf } from 'immutable';
import { IMessage } from 'types/messages';

import { StandardAction } from '../types';
import ChatMessagesAction from './chat-messages.action';
import { IChatMessagesState } from './types';

const initData: IChatMessagesState = {
  data: {},
};

const initialState = Record(initData)(initData);

export default class ChatMessagesReducer {
  static getReducer(
    state: RecordOf<IChatMessagesState> = initialState,
    action: StandardAction,
  ): RecordOf<IChatMessagesState> {
    switch (action.type) {
      case ChatMessagesAction.ACTION_TYPES.SET_CHAT_MESSAGES:
      case ChatMessagesAction.ACTION_TYPES.RESET_CHAT_MESSAGES:
        return ChatMessagesReducer.handleChatMessages(state, action);

      default:
        return state;
    }
  }

  static handleChatMessages = (
    state: RecordOf<IChatMessagesState>,
    action: StandardAction<{ target: string; messages: IMessage[] }>,
  ): RecordOf<IChatMessagesState> => {
    const { payload } = action;
    switch (action.type) {
      case ChatMessagesAction.ACTION_TYPES.SET_CHAT_MESSAGES:
        const newTargetMessages = payload?.target ? { [payload.target]: payload?.messages } : {};
        return {
          ...state,
          data: {
            ...state.data,
            ...newTargetMessages,
          },
        };

      case ChatMessagesAction.ACTION_TYPES.RESET_CHAT_MESSAGES:
        return {
          ...state,
          data: {},
        };

      default:
        return state;
    }
  };
}
